export class Folder {

    public id: string = "0";
    public name: string;
    
    constructor() {}
}